import { Typography } from "@material-ui/core";
import React from "react";
import {makeStyles} from "@material-ui/core/styles";
import { EMPTY_DATA_IMG } from "../../constants/CoreConstants";

const useStyles = makeStyles({
  wrapper: (props) => ({
    display: "flex",
    flexDirection: "column-reverse",
    alignItems: "center",
    justifyContent: "center",
    height: `calc(100vh - ${props.maxHeight})`,
  }),
  leftSide: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    marginTop: "20px",
  },
  rightSide: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  message: {
    fontWeight: 600,
    height: "unset !important",
  },
});

const GlobalEmptyPage = ({emptyPageMessage = "No data found", imgSrc=EMPTY_DATA_IMG, maxHeight = '360px'}) => {
  const classes = useStyles({ maxHeight });

  return (
    <div  className={classes.wrapper}>
      <div className={classes.leftSide}>
          <Typography className={classes.message} align="center" variant="h5">
           {emptyPageMessage}
          </Typography>
      </div>
      <div className={classes.rightSide}>
        <img
          height={300}
          src={imgSrc}
          alt="Empty data"
        />
      </div>
    </div>
  );
};

export default GlobalEmptyPage;